import { motion } from "motion/react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

export function Stats() {
  return (
    <section className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="px-4 py-2 rounded-full bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-600/30 text-purple-600">
              なぜ必要か
            </span>
            <h2 className="mt-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
              "PayPay使える？"で<br />店を選ぶ時代
            </h2>
            <p className="mt-4 text-muted-foreground">
              来店前に決済手段を確認するお客さまが増加中。<br />
              SNSや店頭だけでは、その情報が届きません。
            </p>

            <div className="mt-12 space-y-8">
              {[
                {
                  value: "91.2%",
                  label: "需要拡大",
                  description: "現金以外で支払う人の割合",
                },
                {
                  value: "複雑化",
                  label: "実際の声",
                  description: "「どのお店でも全部使えれば良いが、場所によっては使えないところもあるのでそれがめんどくさい。」",
                },
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-start gap-4"
                >
                  <div className="flex-shrink-0 w-16 h-16 rounded-xl bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center">
                    <span className="text-white text-sm text-center leading-tight">{stat.value}</span>
                  </div>
                  <div>
                    <h4>{stat.label}</h4>
                    <p className="text-muted-foreground text-sm mt-1">
                      {stat.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
            
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
              className="mt-8 text-xs text-muted-foreground"
            >
              出典：内閣府 消費者委員会「支払手段の多様化等に関するアンケート調査（消費者向け）」Q5（2025年3月実施、n=3,668）
            </motion.p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <ImageWithFallback
                src="https://images.unsplash.com/photo-1666017525287-4ef2270a1ed1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMGJ1c2luZXNzJTIwY2FmZXxlbnwxfHx8fDE3NjA3Nzc3NjV8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
                alt="小規模ビジネスのカフェ - キャッシュレス決済対応店舗"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-purple-600/20 to-blue-600/20" />
            </div>
            
            {/* Floating Card */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
              className="absolute -bottom-6 -left-6 bg-card border border-border rounded-xl p-6 shadow-xl max-w-xs"
            >
              <div className="mb-3">
                <div className="text-muted-foreground text-sm mb-1">課題</div>
                <p className="text-sm">決済方法の種類が多様化。<br />ユーザは使える決済方法を調べたい。<br />SNSや店頭掲示だけでは不十分。</p>
              </div>
              <div className="pt-3 border-t border-border">
                <div className="text-muted-foreground text-sm mb-1">解決策</div>
                <div className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent text-sm">
                  地図で検索可能にする
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
